// No imports needed

export interface IJupiterQuoteResponse {
    success: boolean
    message: string
    liquidity_source: string
    src_token: {
        token_id: string
        chain_id: string
        address: string
        symbol: string
        name: string
        decimals: number
        image: string
        price: number
        market_cap: number
        volume_24h: number
        high_24h: number
        low_24h: number
        price_change_24h: number
        price_change_percentage_24h: number
        last_updated: string
    }
    dst_token: {
        token_id: string
        chain_id: string
        address: string
        symbol: string
        name: string
        decimals: number
        image: string
        price: number
        market_cap: number
        volume_24h: number
        high_24h: number
        low_24h: number
        price_change_24h: number
        price_change_percentage_24h: number
        last_updated: string
    }
    src_token_quantity: string
    dst_token_quantity: string
    created_at: string
    expires_at: string
    miles: number
    fees: {
        gas_cost_usd: number
        relay_fee_usd: number
    }
    order_data: any
    jupiter_quote: {
        inputMint: string
        inAmount: string
        outputMint: string
        outAmount: string
        otherAmountThreshold: string
        swapMode: string
        slippageBps: number
        platformFee: any
        priceImpactPct: string
        routePlan: Array<{
            swapInfo: {
                ammKey: string
                label: string
                inputMint: string
                outputMint: string
                inAmount: string
                outAmount: string
                feeAmount: string
                feeMint: string
            }
            percent: number
        }>
        contextSlot: number
    }
    tx_data: {
        tokenLedgerInstruction: any
        computeBudgetInstructions: Array<{
            programId: string
            accounts: Array<any>
            data: string
        }>
        setupInstructions: Array<{
            programId: string
            accounts: Array<{
                pubkey: string
                isSigner: boolean
                isWritable: boolean
            }>
            data: string
        }>
        swapInstruction: {
            programId: string
            accounts: Array<{
                pubkey: string
                isSigner: boolean
                isWritable: boolean
            }>
            data: string
        }
        cleanupInstruction: any
        addressLookupTableAddresses: string[]
        addressLookupTableData: {
            lookupTables: Array<{
                address: string
                data: number
                executable: boolean
                lamports: number
                owner: string
                rentEpoch: number
            }>
            recentBlockhash: string
            lastValidBlockHeight: number
        }
        addressLookupTableAccounts: any
        recentBlockhash: string
        lastValidBlockHeight: number
        includesBlockhash: boolean
        prioritizationFeeLamports: number
    }
}

export interface IJupiterOrderCreateResponse {
    orderId: string
    status: string
    createdAt: string
    expiresAt: string
}

export interface IJupiterOrderStatusResponse {
    orderId: string
    status: string
    createdAt: string
    updatedAt: string
    depositTxHash?: string
    completedAt?: string
    error?: string
}

export enum JupiterOrderStatus {
    AWAITING_DEPOSIT = 'AWAITING_DEPOSIT',
    DEPOSIT_DETECTED = 'DEPOSIT_DETECTED',
    PROCESSING = 'PROCESSING',
    SENDING_TO_DESTINATION = 'SENDING_TO_DESTINATION',
    COMPLETED = 'COMPLETED',
    EXPIRED = 'EXPIRED',
    FAILED = 'FAILED',
}
